import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: CustomHttpService) { }

  getAllRegistrations(data:any): Observable<any> {
    return this.http.post(environment.getAllRegistrations,data);
  }

  createDocument(data:any): Observable<any> {
    return this.http.post(environment.createDocument,data);
  }

  deleteBulkRegistration(data:any): Observable<any> {
    return this.http.post(environment.deleteBulkRegistration,data);
  }

  deleteRegistration(data:any): Observable<any> {
    return this.http.post(environment.deleteRegistration,data);
  }

  getAllCourses(data:any): Observable<any> {
    return this.http.post(environment.getAllCourses,data);
  }
}

